var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    location,
    property_value,
    loan_amount,
    loan_types,
    home_equity_value,
  } = options;

__p+='\n\n<!-- search description -->\n<span>Based on:</span><br>\n<p class=\'description\'>'+
((__t=( location ))==null?'':__t)+
',  '+
((__t=( loan_amount ))==null?'':__t)+
' , '+
((__t=( loan_types ))==null?'':__t)+
', with '+
((__t=( home_equity_value ))==null?'':__t)+
' equity in current home.</p>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/home_equity_rate_table_search_description.jst.ejs